import React, { useEffect } from "react";
import { useUserStore } from "../../stores/useUserStore";
import { useLocation, useNavigate } from "react-router-dom";
import useLogout from "../api/useLogout";
import { SelectItem } from "../../components/inputs/SelectInput";
import useScreenSize from "../utils/useScreenSize";
import useIsOpen from "../utils/useIsOpen";
import { useMeetingStore } from "../../stores/useMeetingStore";
import useLeaveMeeting from "../api/useLeaveMeeting";
import {
    getStoredParticipantInfo,
    clearParticipantInfo,
} from "../utils/useMeetingFromParams";
import logExit from "../../utilities/exitLogger";

const useHeader = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const user = useUserStore((state) => state.user);
    const meeting = useMeetingStore((state) => state.meeting);
    const { leaveMeeting } = useLeaveMeeting();

    // const { xsOrsm } = useScreenSize();
    const [menuOpen, _, closeMenu, toggleMenu] = useIsOpen(false);

    // useEffect(() => {}, []);

    const logout = useLogout();

    const isHome = location.pathname === "/";
    const isSettings = location.pathname === "/settings";

    const toHome = () => {
        navigate(`/`);
        closeMenu();
    };
    const toSettings = () => {
        navigate(`/settings`);
        closeMenu();
    };
    const toLogin = async () => {
        // 监控：用户主动点击登出（正常路径，非异常）
        logExit("manual-logout", { userId: user.id, meetingId: meeting?.id });
        // 若当前正作为参会者身处某个会议中，登出前先调用 Leave，
        // 让服务端将其置为离线并广播 MeetingChanged，host 端才会同步移除该参会者。
        // host 未通过参会者身份加入，不会有 stored participant info，因此不受影响。
        if (meeting) {
            const stored = getStoredParticipantInfo(meeting.id);
            if (stored?.name) {
                await leaveMeeting(stored.name);
                clearParticipantInfo(meeting.id);
            }
        }
        logout();
        navigate("/login");
        closeMenu();
    };

    return {
        user,
        isHome,
        isSettings,
        menuOpen,

        closeMenu,
        toggleMenu,
        toHome,
        toSettings,
        toLogin,
    };
};

export default useHeader;
